/* eslint-disable no-unused-vars */

import {
  convertInchesToMillimeter,
  convertMillimeterToInches
} from '@utilities/conversion-mm-inch';

const initialConversionWhenDataIsLoaded = ({
  cachedData,
  picklistsMap,
  shellTminAndHeadTminValue,
  selectedUnit
}) => {
  let openTminTextBox = false;
  let formFieldNameAndConvertedValue = {};
  const componentValue = cachedData?.component || '';

  if (componentValue) {
    const isHeadSelected = picklistsMap[componentValue]?.value === 'Head' ? true : false;
    const isShellSelected = picklistsMap[componentValue]?.value === 'Shell' ? true : false;

    openTminTextBox = checkHeadOrShellIsSelectedOrNot({ isHeadSelected, isShellSelected });

    if (isHeadSelected && shellTminAndHeadTminValue?.headTmin) {
      formFieldNameAndConvertedValue = headSelectedCase({
        picklistsMap,
        shellTminAndHeadTminValue,
        cachedData,
        selectedUnit
      });
    } else if (isShellSelected && shellTminAndHeadTminValue?.shellTmin) {
      formFieldNameAndConvertedValue = shellSelectedCase({
        picklistsMap,
        shellTminAndHeadTminValue,
        cachedData,
        selectedUnit
      });
    } else if (isHeadSelected || isShellSelected) {
      formFieldNameAndConvertedValue = {
        tminBoxValue: null,
        tminFormValue: '',
        fieldName: ''
      };
    }
  }

  return {
    ...formFieldNameAndConvertedValue,
    openTminTextBox
  };
};

const checkHeadOrShellIsSelectedOrNot = ({ isShellSelected, isHeadSelected }) => {
  if (isShellSelected || isHeadSelected) {
    return true;
  } else {
    return false;
  }
};

const headSelectedCase = ({
  picklistsMap,
  shellTminAndHeadTminValue,
  cachedData,
  selectedUnit
}) => {
  const unit =
    picklistsMap[shellTminAndHeadTminValue?.headTminUnit]?.lookupValue === 'mm' ? 'mm' : 'in';

  if (!cachedData.selectedLengthUnit) {
    if (unit === 'mm') {
      const valueMMToInches = convertMillimeterToInches({
        value: shellTminAndHeadTminValue?.headTmin,
        toFixed: 8
      });
      let textBoxValue = Number(valueMMToInches);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tmin' });
      return {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: valueMMToInches,
        fieldName: 'tmin'
      };
    } else if (unit === 'in') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.headTmin);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tmin' });
      return {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.headTmin,
        fieldName: 'tmin'
      };
    }
  } else {
    if (cachedData.selectedLengthUnit === 'in' && unit === 'mm') {
      const valueMMToInches = convertMillimeterToInches({
        value: shellTminAndHeadTminValue?.headTmin,
        toFixed: 8
      });

      let textBoxValue = Number(valueMMToInches);
      let newValue = textBoxValue.toFixed(cachedData.selectedLengthUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tmin' });

      return {
        tminBoxValue: `${convertedValue} ${cachedData.selectedLengthUnit}`,
        tminFormValue: valueMMToInches,
        fieldName: 'tmin'
      };
    } else if (cachedData.selectedLengthUnit === 'mm' && unit === 'in') {
      const valueInchesToMM = convertInchesToMillimeter({
        value: shellTminAndHeadTminValue?.headTmin,
        toFixed: 6
      });

      let textBoxValue = Number(valueInchesToMM);
      let newValue = textBoxValue.toFixed(cachedData.selectedLengthUnit === 'in' ? 5 : 6);

      let convertedValue = splitDecimalPoint({ newValue, name: 'tminOnMM' });

      return {
        tminBoxValue: `${convertedValue} ${cachedData.selectedLengthUnit}`,
        tminFormValue: valueInchesToMM,
        fieldName: 'tminOnMM'
      };
    } else if (cachedData.selectedLengthUnit === 'in' && unit === 'in') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.headTmin);
      let newValue = textBoxValue.toFixed(cachedData.selectedLengthUnit === 'in' ? 5 : 6);

      let convertedValue = splitDecimalPoint({ newValue, name: 'tmin' });

      return {
        tminBoxValue: `${convertedValue} ${cachedData.selectedLengthUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.headTmin,
        fieldName: 'tmin'
      };
    } else if (cachedData.selectedLengthUnit === 'mm' && unit === 'mm') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.headTmin);
      let newValue = textBoxValue.toFixed(cachedData.selectedLengthUnit === 'in' ? 5 : 6);

      let convertedValue = splitDecimalPoint({ newValue, name: 'tminOnMM' });

      return {
        tminBoxValue: `${convertedValue} ${cachedData.selectedLengthUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.headTmin,
        fieldName: 'tminOnMM'
      };
    }
  }
};

const shellSelectedCase = ({
  picklistsMap,
  shellTminAndHeadTminValue,
  cachedData,
  selectedUnit
}) => {
  const unit =
    picklistsMap[shellTminAndHeadTminValue?.shellTminUnit]?.lookupValue === 'mm' ? 'mm' : 'in';

  if (!cachedData.selectedLengthUnit) {
    if (unit === 'mm') {
      const valueMMToInches = convertMillimeterToInches({
        value: shellTminAndHeadTminValue?.shellTmin,
        toFixed: 8
      });
      let textBoxValue = Number(valueMMToInches);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tmin' });
      return {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: valueMMToInches,
        fieldName: 'tmin'
      };
    } else if (unit === 'in') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.shellTmin);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tmin' });
      return {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.shellTmin,
        fieldName: 'tmin'
      };
    }
  } else {
    if (cachedData.selectedLengthUnit === 'in' && unit === 'mm') {
      const valueMMToInches = convertMillimeterToInches({
        value: shellTminAndHeadTminValue?.shellTmin,
        toFixed: 8
      });

      let textBoxValue = Number(valueMMToInches);
      let newValue = textBoxValue.toFixed(cachedData.selectedLengthUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tmin' });

      return {
        tminBoxValue: `${convertedValue} ${cachedData.selectedLengthUnit}`,
        tminFormValue: valueMMToInches,
        fieldName: 'tmin'
      };
    } else if (cachedData.selectedLengthUnit === 'mm' && unit === 'in') {
      const valueInchesToMM = convertInchesToMillimeter({
        value: shellTminAndHeadTminValue?.shellTmin,
        toFixed: 6
      });

      let textBoxValue = Number(valueInchesToMM);
      let newValue = textBoxValue.toFixed(cachedData.selectedLengthUnit === 'in' ? 5 : 6);

      let convertedValue = splitDecimalPoint({ newValue, name: 'tminOnMM' });

      return {
        tminBoxValue: `${convertedValue} ${cachedData.selectedLengthUnit}`,
        tminFormValue: valueInchesToMM,
        fieldName: 'tminOnMM'
      };
    } else if (cachedData.selectedLengthUnit === 'in' && unit === 'in') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.shellTmin);
      let newValue = textBoxValue.toFixed(cachedData.selectedLengthUnit === 'in' ? 5 : 6);

      let convertedValue = splitDecimalPoint({ newValue, name: 'tmin' });

      return {
        tminBoxValue: `${convertedValue} ${cachedData.selectedLengthUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.shellTmin,
        fieldName: 'tmin'
      };
    } else if (cachedData.selectedLengthUnit === 'mm' && unit === 'mm') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.shellTmin);
      let newValue = textBoxValue.toFixed(cachedData.selectedLengthUnit === 'in' ? 5 : 6);

      let convertedValue = splitDecimalPoint({ newValue, name: 'tminOnMM' });

      return {
        tminBoxValue: `${convertedValue} ${cachedData.selectedLengthUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.shellTmin,
        fieldName: 'tminOnMM'
      };
    }
  }
};

const splitDecimalPoint = ({ newValue, name }) => {
  let pointValue = ['tmin', 'tminOnMM'].includes(name) ? 4 : 3;
  let originalValue = newValue;
  originalValue = originalValue.toString();
  let [valueWithoutDecimal, decimalValue] = originalValue.split('.');

  let latestValue = newValue;
  if (decimalValue) {
    if (decimalValue.split('').length === pointValue) {
      latestValue = newValue;
    } else {
      let checkLastValueOfDecimal = decimalValue.slice(-1);

      if (checkLastValueOfDecimal === '0') {
        let valueAfterRemovingLastDigitOnDecimalPoint = decimalValue.slice(0, -1);
        checkLastValueOfDecimal = valueAfterRemovingLastDigitOnDecimalPoint.slice(-1);
        if (checkLastValueOfDecimal !== '0') {
          let bo = decimalValue.slice(0, -1);
          latestValue = `${valueWithoutDecimal}.${bo}`;
        } else if (checkLastValueOfDecimal === '0') {
          let bo = decimalValue.slice(0, pointValue);
          latestValue = bo;
          latestValue = `${valueWithoutDecimal}.${bo}`;
        }
      } else {
        latestValue = newValue;
      }
    }
  } else {
    latestValue = newValue;
  }

  return latestValue;
};

const setTminValueWhenCOmponentValueIsChanged = ({
  picklistsMap,
  componentValue,
  shellTminAndHeadTminValue,
  selectedUnit,
  cachedData
}) => {
  let openTminTextBox = false;
  let formFieldNameAndConvertedValue = {};

  const isHeadSelected = picklistsMap[componentValue]?.value === 'Head' ? true : false;
  const isShellSelected = picklistsMap[componentValue]?.value === 'Shell' ? true : false;

  openTminTextBox = checkHeadOrShellIsSelectedOrNot({ isHeadSelected, isShellSelected });

  if (isHeadSelected && shellTminAndHeadTminValue?.headTmin) {
    const unitTmin =
      picklistsMap[shellTminAndHeadTminValue?.headTminUnit]?.lookupValue === 'mm' ? 'mm' : 'in';

    if (selectedUnit === 'in' && unitTmin === 'mm') {
      const valueMMToInches = convertMillimeterToInches({
        value: shellTminAndHeadTminValue?.headTmin,
        toFixed: 8
      });

      let textBoxValue = Number(valueMMToInches);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({
        newValue: newValue,
        name: 'tmin'
      });
      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: valueMMToInches,
        fieldName: 'tmin'
      };
    } else if (selectedUnit === 'mm' && unitTmin === 'in') {
      const valueInchesToMM = convertInchesToMillimeter({
        value: shellTminAndHeadTminValue?.headTmin,
        toFixed: 6
      });

      let textBoxValue = Number(valueInchesToMM);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);

      let convertedValue = splitDecimalPoint({ newValue, name: 'tminOnMM' });

      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: valueInchesToMM,
        fieldName: 'tminOnMM'
      };
    } else if (selectedUnit === 'in' && unitTmin === 'in') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.headTmin);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tmin' });
      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.headTmin,
        fieldName: 'tmin'
      };
    } else if (selectedUnit === 'mm' && unitTmin === 'mm') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.headTmin);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tminOnMM' });

      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.headTmin,
        fieldName: 'tminOnMM'
      };
    }
  } else if (isShellSelected && shellTminAndHeadTminValue?.shellTmin) {
    const unitTmin =
      picklistsMap[shellTminAndHeadTminValue?.shellTminUnit]?.lookupValue === 'mm' ? 'mm' : 'in';

    if (selectedUnit === 'in' && unitTmin === 'mm') {
      const valueMMToInches = convertMillimeterToInches({
        value: shellTminAndHeadTminValue?.shellTmin,
        toFixed: 8
      });

      let textBoxValue = Number(valueMMToInches);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({
        newValue: newValue,
        name: 'tmin'
      });
      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: valueMMToInches,
        fieldName: 'tmin'
      };
    } else if (selectedUnit === 'mm' && unitTmin === 'in') {
      const valueInchesToMM = convertInchesToMillimeter({
        value: shellTminAndHeadTminValue?.shellTmin,
        toFixed: 6
      });

      let textBoxValue = Number(valueInchesToMM);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);

      let convertedValue = splitDecimalPoint({ newValue, name: 'tminOnMM' });

      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: valueInchesToMM,
        fieldName: 'tminOnMM'
      };
    } else if (selectedUnit === 'in' && unitTmin === 'in') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.shellTmin);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tmin' });
      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.shellTmin,
        fieldName: 'tmin'
      };
    } else if (selectedUnit === 'mm' && unitTmin === 'mm') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.shellTmin);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tminOnMM' });

      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.shellTmin,
        fieldName: 'tminOnMM'
      };
    }
  } else if (cachedData?.tmin?.textBoxValue || cachedData?.tminOnMM?.textBoxValue) {
    const value =
      selectedUnit === 'in' ? cachedData?.tmin?.textBoxValue : cachedData?.tminOnMM?.textBoxValue;

    formFieldNameAndConvertedValue = {
      tminBoxValue: null,
      tminFormValue: value,
      fieldName: selectedUnit === 'in' ? 'tmin' : 'tminOnMM',
      changeDecimalValueBasedOnUnit: true
    };
  } else {
    formFieldNameAndConvertedValue = {
      tminBoxValue: null,
      tminFormValue: '',
      fieldName: selectedUnit === 'in' ? 'tmin' : 'tminOnMM',
      changeDecimalValueBasedOnUnit: false
    };
  }

  return {
    ...formFieldNameAndConvertedValue,
    openTminTextBox
  };
};

const setValueWhenUnitIsChanged = ({
  picklistsMap,
  selectedUnit,
  componentValue,
  shellTminAndHeadTminValue
}) => {
  const isHeadSelected = picklistsMap[componentValue]?.value === 'Head' ? true : false;
  const isShellSelected = picklistsMap[componentValue]?.value === 'Shell' ? true : false;
  let openTminTextBox = false;
  let formFieldNameAndConvertedValue = {};

  openTminTextBox = checkHeadOrShellIsSelectedOrNot({ isHeadSelected, isShellSelected });

  if (isHeadSelected && shellTminAndHeadTminValue?.headTmin) {
    const unitTmin =
      picklistsMap[shellTminAndHeadTminValue?.headTminUnit]?.lookupValue === 'mm' ? 'mm' : 'in';

    if (selectedUnit === 'in' && unitTmin === 'mm') {
      const valueMMToInches = convertMillimeterToInches({
        value: shellTminAndHeadTminValue?.headTmin,
        toFixed: 8
      });

      let textBoxValue = Number(valueMMToInches);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({
        newValue: newValue,
        name: 'tmin'
      });
      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: valueMMToInches,
        fieldName: 'tmin'
      };
    } else if (selectedUnit === 'mm' && unitTmin === 'in') {
      const valueInchesToMM = convertInchesToMillimeter({
        value: shellTminAndHeadTminValue?.headTmin,
        toFixed: 6
      });

      let textBoxValue = Number(valueInchesToMM);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);

      let convertedValue = splitDecimalPoint({ newValue, name: 'tminOnMM' });

      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: valueInchesToMM,
        fieldName: 'tminOnMM'
      };
    } else if (selectedUnit === 'in' && unitTmin === 'in') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.headTmin);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tmin' });
      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.headTmin,
        fieldName: 'tmin'
      };
    } else if (selectedUnit === 'mm' && unitTmin === 'mm') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.headTmin);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tminOnMM' });

      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.headTmin,
        fieldName: 'tminOnMM'
      };
    }
  } else if (isShellSelected && shellTminAndHeadTminValue?.shellTmin) {
    const unitTmin =
      picklistsMap[shellTminAndHeadTminValue?.shellTminUnit]?.lookupValue === 'mm' ? 'mm' : 'in';

    if (selectedUnit === 'in' && unitTmin === 'mm') {
      const valueMMToInches = convertMillimeterToInches({
        value: shellTminAndHeadTminValue?.shellTmin,
        toFixed: 8
      });

      let textBoxValue = Number(valueMMToInches);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({
        newValue: newValue,
        name: 'tmin'
      });
      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: valueMMToInches,
        fieldName: 'tmin'
      };
    } else if (selectedUnit === 'mm' && unitTmin === 'in') {
      const valueInchesToMM = convertInchesToMillimeter({
        value: shellTminAndHeadTminValue?.shellTmin,
        toFixed: 6
      });

      let textBoxValue = Number(valueInchesToMM);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);

      let convertedValue = splitDecimalPoint({ newValue, name: 'tminOnMM' });

      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: valueInchesToMM,
        fieldName: 'tminOnMM'
      };
    } else if (selectedUnit === 'in' && unitTmin === 'in') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.shellTmin);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tmin' });
      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.shellTmin,
        fieldName: 'tmin'
      };
    } else if (selectedUnit === 'mm' && unitTmin === 'mm') {
      let textBoxValue = Number(shellTminAndHeadTminValue?.shellTmin);
      let newValue = textBoxValue.toFixed(selectedUnit === 'in' ? 5 : 6);
      let convertedValue = splitDecimalPoint({ newValue, name: 'tminOnMM' });

      formFieldNameAndConvertedValue = {
        tminBoxValue: `${convertedValue} ${selectedUnit}`,
        tminFormValue: shellTminAndHeadTminValue?.shellTmin,
        fieldName: 'tminOnMM'
      };
    }
  } else if (isHeadSelected || isShellSelected) {
    formFieldNameAndConvertedValue = {
      tminBoxValue: null,
      tminFormValue: '',
      fieldName: ''
    };
  }

  return {
    ...formFieldNameAndConvertedValue,
    openTminTextBox
  };
};

export {
  initialConversionWhenDataIsLoaded,
  setTminValueWhenCOmponentValueIsChanged,
  setValueWhenUnitIsChanged
};
